import { render, staticRenderFns } from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=template&id=e2f0d2b2&scoped=true"
import script from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderSubletHeadingsComponent.vue?vue&type=style&index=0&id=e2f0d2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f0d2b2",
  null
  
)

export default component.exports